var jade = require("/home/romain/Cozy/cozy-proxy/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (t) {
buf.push("<a href=\"/register?step=null\" class=\"btn btn-primary\">" + (jade.escape(null == (jade_interp = t('next')) ? "" : jade_interp)) + "</a>");}.call(this,"t" in locals_for_with?locals_for_with.t:typeof t!=="undefined"?t:undefined));;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./app/views/templates/view_register_controls.jade
 ** module id = 73
 ** module chunks = 0
 **/